import React, { Component } from "react";
import { alert, loading, t } from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";

import HomeNavbar from "./components/HomeNavbar.js";
import HomeFooter from "./components/HomeFooter.js";
import PartnerField from "./components/PartnerField.js";

import ICON from "./icons.js";
import { openFreePost } from "./options.js";
import {
  OTP_LENGTH,
  OTP_RESEND_SEC,
  OTP_EXPIRE_SEC,
  PASSWORD_MIN_LENGTH,
  countdown,
  maskEmail,
} from "./partner_option.js";
import { forgotPassword, resetPassword } from "../../services/partner.service.js";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import "../../assets/css/homepage.css";
import "../../assets/css/partner.css";

/* ============================================================================
 * PartnerForgot — ตั้งรหัสผ่านใหม่ของบัญชีพาร์ตเนอร์ (/partner/forgot-password)
 *
 * เป็นหน้าเต็มไม่ใช่ป๊อปอัป เพราะเป็นขั้นตอนหลายจังหวะที่ต้องสลับไปเปิดกล่องจดหมาย
 * แล้วกลับมา — ถ้าอยู่ในป๊อปอัปที่ซ้อนบนกล่องเข้าสู่ระบบ ผู้ใช้จะปิดทิ้งโดยไม่ตั้งใจได้ง่าย
 *
 * ใช้ได้เฉพาะบัญชีพาร์ตเนอร์ — server ปฏิเสธอีเมลของผู้ใช้ภายในไว้ ไม่งั้นเส้นทาง
 * สาธารณะนี้จะกลายเป็นทางขอรหัสตั้งรหัสผ่านใหม่ให้บัญชีผู้ดูแลระบบ
 *
 * สองขั้น :
 *   1. email  กรอกอีเมล → ระบบส่งรหัสไปให้
 *   2. reset  กรอกรหัส + รหัสผ่านใหม่ → จบในคำขอเดียว
 * ไม่มีขั้น "ยืนยันรหัสก่อนแล้วค่อยตั้งรหัสผ่าน" แยกออกมา เพราะระหว่างสองขั้นนั้น
 * ไม่มีอะไรต้องทำเลย (ต่างจากตอนสมัครที่มีการอัปเอกสารคั่น จึงต้องมีตั๋วถือไว้)
 * ========================================================================== */
class PartnerForgot extends Component {
  state = {
    step: "email",
    email: "",
    code: "",
    password: "",
    password_confirm: "",
    show: false,
    errors: {},
    sending: false,
    resend_in: 0,
    expire_in: 0,
    dev_code: "",
    mail_sent: true,
    done: false,
  };

  componentDidMount() {
    document.title = `${t("partner_forgot_title")} | SafeSpace Life Living`;
    /* ตัวหมุนโหลด (#loading ใน index.js) ขึ้นคลุมทั้งจอมาตั้งแต่เปิดเว็บ ทุกหน้าต้องสั่งปิดเอง
       หน้านี้เปิดมาเป็นฟอร์มเปล่า ไม่ได้ยิง API จนกว่าผู้ใช้จะกดขอรหัส จึงไม่มีใครปิดให้
       ถ้าไม่ปิดตรงนี้ คนที่กดรีเฟรชหรือเปิดลิงก์นี้ตรง ๆ จะเจอฉากทึบค้างจนกดอะไรไม่ได้
       (สูตรเดียวกับหน้าใบสมัครใน partner.js) */
    loading(false);
    window.scrollTo({ top: 0 });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  /* นาฬิกาเดียวเดินทั้งสองตัวนับ (ขอรหัสใหม่ได้เมื่อไร / รหัสหมดอายุเมื่อไร) */
  tick = () => {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.setState((state) => {
        const expire_in = Math.max(0, state.expire_in - 1);
        if (!expire_in) clearInterval(this.timer);
        return { resend_in: Math.max(0, state.resend_in - 1), expire_in };
      });
    }, 1000);
  };

  setField = (patch) =>
    this.setState((state) => {
      const errors = { ...state.errors };
      Object.keys(patch).forEach((key) => delete errors[key]);
      return { ...patch, errors };
    });

  /* ------------------------------------------------- ขั้นที่ 1 : ขอรหัส */
  Send = async () => {
    const { email, sending, resend_in } = this.state;

    if (sending || resend_in > 0) return;
    if (!email.trim()) return this.setState({ errors: { email: "partner_status_require_email" } });
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) return this.setState({ errors: { email: "partner_invalid_email" } });

    this.setState({ sending: true, errors: {} });
    loading(true);
    const result = await forgotPassword(email);
    loading(false);
    this.setState({ sending: false });

    // POST เด้งข้อความจาก API ให้แล้วเมื่อไม่สำเร็จ จึงไม่ต้องเตือนซ้ำ
    if (result?.status !== true) return;

    /* เริ่มนับถอยหลัง "หลัง" API ตอบสำเร็จเท่านั้น — ถ้าเริ่มก่อน คนที่โดนปฏิเสธ
       (ไม่มีบัญชี / ขอถี่เกินไป) จะเห็นตัวนับเดินอยู่ทั้งที่ไม่มีรหัสถูกส่งไปไหนเลย
       ค่าอายุใช้ที่ server ส่งกลับมา ไม่ใช่ค่าคงที่ฝั่งนี้ เผื่อ backend ปรับเพดาน */
    this.setState({
      step: "reset",
      code: "",
      resend_in: Number(result.data?.resend_in) || OTP_RESEND_SEC,
      expire_in: Number(result.data?.expires_in) || OTP_EXPIRE_SEC,
      dev_code: result.data?.dev_code || "",
      mail_sent: result.data?.sent !== false,
    });
    this.tick();
  };

  /* ---------------------------------------- ขั้นที่ 2 : ตั้งรหัสผ่านใหม่ */
  validateReset = () => {
    const { code, password, password_confirm, expire_in } = this.state;
    const errors = {};

    if (code.replace(/[^0-9]/g, "").length !== OTP_LENGTH) errors.code = "partner_otp_incomplete";
    else if (!expire_in) errors.code = "partner_otp_expired";

    if (!password) errors.password = "partner_require_password";
    else if (password.length < PASSWORD_MIN_LENGTH) errors.password = "partner_password_short";
    else if (password !== password_confirm) errors.password_confirm = "partner_password_mismatch";

    this.setState({ errors });
    return !Object.keys(errors).length;
  };

  Reset = async () => {
    if (this.state.sending || !this.validateReset()) return;

    this.setState({ sending: true });
    loading(true);
    const result = await resetPassword(this.state.email, this.state.code, this.state.password);
    loading(false);
    this.setState({ sending: false });

    if (result?.status !== true) return;

    clearInterval(this.timer);
    /* ล้างรหัสผ่านออกจากหน่วยความจำของหน้าทันทีที่ใช้เสร็จ ไม่ค้างไว้ใน state
       ของหน้าที่ยังเปิดอยู่ต่อ */
    this.setState({
      done: true,
      code: "",
      password: "",
      password_confirm: "",
      dev_code: "",
      expire_in: 0,
      resend_in: 0,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  soon = (name) => alert("", "info", t("coming_soon_title"), `${name} — ${t("coming_soon_desc")}`, t("confirm"));

  /* ------------------------------------------------------------- render */
  renderEmailStep = () => {
    const { email, errors, sending } = this.state;

    return (
      <>
        <p className="hm-pt-note pt-3">{t("partner_forgot_email_desc")}</p>

        {/* ช่องอีเมลกับปุ่มขอรหัสอยู่แถวเดียวกัน — ขั้นนี้มีงานเดียวคือกรอกอีเมลแล้วส่ง
            แยกปุ่มลงบรรทัดใหม่จะทำให้การ์ดโล่งและตาต้องกวาดสองจังหวะโดยไม่จำเป็น
            ใช้ as="div" เพราะมีปุ่มอยู่ข้างใน ถ้าเป็น <label> การกดปุ่มจะไปโฟกัสช่องกรอกด้วย */}
        <PartnerField as="div" label={t("partner_email")} required error={errors.email}>
          <span className="hm-pt-inline">
            <input
              type="email"
              className="hm-pt-input"
              placeholder={t("partner_email_placeholder")}
              value={email}
              onChange={(e) => this.setField({ email: e.target.value })}
              onKeyUp={(e) => e.key === "Enter" && this.Send()}
            />
            <button type="button" className="hm-btn hm-btn--primary" disabled={sending} onClick={this.Send}>
              <span className="hm-ico">{ICON.mail}</span>
              {sending ? t("partner_otp_sending") : t("partner_forgot_send")}
            </button>
          </span>
        </PartnerField>
      </>
    );
  };

  renderResetStep = () => {
    const { email, code, password, password_confirm, show, errors, sending, resend_in, expire_in, dev_code, mail_sent } =
      this.state;

    return (
      <>
        <p className="hm-pt-note">
          {t("partner_forgot_reset_desc")} <b>{maskEmail(email)}</b>
        </p>

        <PartnerField label={t("partner_forgot_code")} required error={errors.code}>
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={OTP_LENGTH}
            className="hm-pt-input hm-pt-input--code"
            placeholder={"".padStart(OTP_LENGTH, "•")}
            value={code}
            disabled={!expire_in}
            onChange={(e) => this.setField({ code: e.target.value.replace(/[^0-9]/g, "") })}
          />
        </PartnerField>

        <div className="hm-pt-otp__row">
          <span className="hm-pt-otp__timer">
            {expire_in ? `${t("partner_otp_expire")} ${countdown(expire_in)}` : t("partner_otp_expired")}
          </span>
          <button type="button" className="hm-pt-link" disabled={resend_in > 0 || sending} onClick={this.Send}>
            {resend_in > 0 ? t("partner_otp_resend_in").replace("{n}", resend_in) : t("partner_otp_resend")}
          </button>
        </div>

        {/* ระบบยังส่งอีเมลจริงไม่ได้ (SMTP ยังไม่ได้ตั้งค่า) — API คืนรหัสมาทางนี้แทน
            ขึ้นทุก environment ระหว่างที่ยังไม่มีเมลเซิร์ฟเวอร์ ต่อ SMTP แล้วจะหายไปเอง */}
        {!!dev_code && (
          <span className="hm-pt-otp__demo">{t("partner_otp_demo").replace("{code}", dev_code)}</span>
        )}
        {!mail_sent && !dev_code && <span className="hm-pt-otp__demo">{t("partner_otp_mail_off")}</span>}

        <div className="hm-pt-grid mt-3">
          <PartnerField
            label={t("partner_forgot_new_password")}
            required
            error={errors.password}
            hint={t("partner_password_hint").replace("{n}", PASSWORD_MIN_LENGTH)}
          >
            <span className="hm-pt-pass">
              <input
                type={show ? "text" : "password"}
                className="hm-pt-input"
                autoComplete="new-password"
                placeholder={t("partner_password_placeholder")}
                value={password}
                onChange={(e) => this.setField({ password: e.target.value })}
              />
              <button
                type="button"
                className="hm-pt-pass__eye"
                aria-label={t("partner_password")}
                aria-pressed={show}
                onClick={() => this.setState({ show: !show })}
              >
                <span className="hm-ico">{show ? ICON.eye_slash : ICON.eye}</span>
              </button>
            </span>
          </PartnerField>

          <PartnerField label={t("partner_password_confirm")} required error={errors.password_confirm}>
            <input
              type={show ? "text" : "password"}
              className="hm-pt-input"
              autoComplete="new-password"
              placeholder={t("partner_password_confirm_placeholder")}
              value={password_confirm}
              onChange={(e) => this.setField({ password_confirm: e.target.value })}
            />
          </PartnerField>
        </div>

        <button type="button" className="hm-btn hm-btn--primary" disabled={sending} onClick={this.Reset}>
          <span className="hm-ico">{ICON.check}</span>
          {sending ? t("partner_submitting") : t("partner_forgot_submit")}
        </button>
      </>
    );
  };

  renderDone = () => (
    <div className="hm-pt-done">
      <span className="hm-pt-done__icon hm-ico">{ICON.check_circle}</span>
      <h2 className="hm-pt-done__title">{t("partner_forgot_done_title")}</h2>
      <p className="hm-pt-done__desc">{t("partner_forgot_done_desc")}</p>

      <div className="hm-pt-done__actions">
        <a className="hm-btn hm-btn--primary" href="/">
          <span className="hm-ico">{ICON.user}</span>
          {t("sign_in")}
        </a>
      </div>
    </div>
  );

  render() {
    const { step, done } = this.state;

    return (
      <div className="mn-home">
        <HomeNavbar onPost={openFreePost} />

        <section className="hm-pt">
          <div className="hm-container">
            <div className="hm-pt__head">
              <span className="hm-pt__kicker">{t("partner_kicker")}</span>
              <h1 className="hm-pt__title">{t("partner_forgot_title")}</h1>
              <p className="hm-pt__desc">{t("partner_forgot_desc")}</p>
            </div>

            <div className="hm-pt__layout hm-pt__layout--narrow hm-pt__layout--solo">
              <div className="hm-pt__main">
                <div className="hm-pt-card">
                  <div className="hm-pt-card__body">
                    {done ? this.renderDone() : step === "email" ? this.renderEmailStep() : this.renderResetStep()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <HomeFooter
          data={{}}
          socials={[]}
          onLink={(key) => this.soon(t(key))}
          onSubscribe={() => this.soon(t("home_footer_subscribe"))}
        />
      </div>
    );
  }
}

export default withRouter(PartnerForgot);
